import {useMutation} from '@tanstack/react-query';
import {OperationStateTypesEnum} from 'presentation/constants/operationStateEnum';
import {postConfirmEmail} from '../../services/postConfirmEmail';
import {AlertEnum} from '../../store/changeDataAlertStore/types';
import {useModalOtpConfirmationStateStore} from '../../store/modalOtpConfirmationStateStore';
import {ConfirmEmailMutationProps} from './types';

export function useConfirmEmailMutation({setChangingEmailState}: ConfirmEmailMutationProps) {
	const setIsModalOtpConfirmationOpen = useModalOtpConfirmationStateStore(
		state => state.updateState,
	);

	return useMutation({
		mutationFn: postConfirmEmail,
		onMutate: async () => {
			setChangingEmailState(OperationStateTypesEnum.PENDING);
		},
		onSuccess: data => {
			setIsModalOtpConfirmationOpen({
				open: true,
				type: AlertEnum.EMAIL,
				data,
			});
			setChangingEmailState(OperationStateTypesEnum.DONE);
		},
		onError: () => {
			setChangingEmailState(OperationStateTypesEnum.UNAVAILABLE);
		},
	});
}
